import { popupClose } from './popup';

export default () => {
  const drop = document.getElementById('dropahint_wrapper');
  if (!drop) return;
  const popup = drop.closest('.popup');
  window.closeClickDropAHint = 1;
  
  const isEmailValid = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const init = () => {
    if (!drop) return;
    drop.addEventListener('click', handleEvents);
    handleShareButtons();
    handleClose();
  };
  
  const handleEvents = () => {
    const timeout = setTimeout(() => {
      const sendButton = document.querySelector('.sendButton');
      if (!sendButton) return;

      sendButton.style.display = 'none';
      const previewWrapper = document.querySelectorAll('.preview-wrapper');
      const container = sendButton.parentNode;
      const inputs = container.querySelectorAll('input, textarea');

      document.body.classList.add('overflow-hidden');
      

      popupClose(popup);

      if (previewWrapper.length === 0) {
        updateElements(container);
      }

      const shadowButton = container.querySelector('.shadow-button');
      shadowButton.style.display = 'block';
      handleShadowButton(inputs, shadowButton, sendButton);
      validateFormButton(inputs, shadowButton, sendButton);

      clearTimeout(timeout);
    }, 250);
  };

  const handleClose = () => {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('grid-item-17')) {
        window.closeClickDropAHint += 1;
      }

      if (event.target.classList.contains('grid-item-17') || event.target.classList.contains('v-icon')) {
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  const validateFormButton = (inputs, shadowButton, realButton) => {
    let isValid = false;
    const validInputs = [];

    inputs.forEach((input) => {
      if (input.closest('.sender_email_input') !== null) return;
      
      let isFocused = true;

      if (input.value === '') {
        validInputs.push(true);
      }

      input.addEventListener('input', () => {
        if (input.type === 'email') {
          isValid = isEmailValid(input.value.trim()) ? true : false;
        }

        if (input.value !== '' && isFocused) {
          validInputs.pop(true);
          isFocused = false;
        }
        if (input.value === '' && !isFocused) {
          validInputs.push(true);
          isFocused = true;
        }
        
        if (validInputs.length === 0 && isValid) {
          realButton.style.display = 'block';
          shadowButton.style.display = 'none';
        } else {
          realButton.style.display = 'none';
          shadowButton.style.display = 'block';
        }

      });
    });
  };

  const validateFormInput = (inputs) => {
    inputs.forEach((input) => {
      const parent = input.type === 'email' || input.type === 'text' ? input.closest('.v-input__control') : input.closest('.preview-content');
      if (!parent) return;

      if (input.value === '') parent.classList.add('input-error');

      if (input.type === 'email') {
        if (!isEmailValid(input.value.trim())) {
          parent.classList.add('input-error');
        }
      }
      
      input.addEventListener('input', () => {
        if (input.value === '') {
          parent.classList.add('input-error');
        } else {
          parent.classList.remove('input-error');
        }
      });
    });
  };

  const handleShadowButton = (inputs, shadowButton, realButton) => {
    shadowButton.addEventListener('click', (event) => {
      event.preventDefault();
      validateFormInput(inputs);
    });
  };

  const handleShareButtons = () => {
    const shareButtons = document.querySelectorAll('.share-button');
    if (!shareButtons) return;

    const shareProperties = (width, height) => {
      const leftPosition = (window.innerWidth / 2) - (width / 2);
      const topPosition = (window.innerHeight / 2) - (height / 2) + 50;
      const options = 'toolbar=0,status=0,resizable=1,width='+ width +',height='+ height +',left='+ leftPosition +',top='+ topPosition +'';
      return { options };
    }

    shareButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        popupClose(popup);
        const property = shareProperties(500, 500);
        const url = button.dataset.url;
        window.open(url, '_blank', property.options);
      });
    });
  };
  
  const updateElements = (container) => {
    const previewWrapper = document.createElement('div');
    previewWrapper.classList.add('preview-wrapper');
    container.appendChild(previewWrapper);

    if (previewWrapper) {
      renderTemplate(previewWrapper);
      renderTextarea(previewWrapper);
    };
  };
    
  const renderTemplate = (container) => {
    const previewTemplate = document.getElementById('preview-template').innerHTML;
    container.insertAdjacentHTML('afterbegin', previewTemplate);
  };

  const renderTextarea = (container) => {
    const content = container.closest('.slideHeight');
    const textarea = content.querySelector('.custom_message_input');
    const hiText = document.querySelector('#layoutDropAHint .grid-item-11');
    const previewDetails = content.querySelector('.preview-content__details');
    const previewHiText = content.querySelector('.preview-content__details-title');
    if (!hiText || !previewDetails) return;
    
    previewHiText.appendChild(hiText);
    previewDetails.appendChild(textarea);
  };

  init();
}